/**
 * @template T
 * @typedef TaskTypeConfig
 * @property {string} id
 * @property {string} label
 * @property {import('@dyl/constants/Skills').SkillId} skill
 * @property {boolean} [v2]
 * @property {BackgroundImagesConfig} [backgroundImages]
 * @property {boolean} [hasEndAudio]
 * @property {() => T} [createItemsTemplate]
 * @property {React.Component} [editor]
 * @property {ConvertToUploadFormat<T>} [convertToUploadFormat]
 * @property {() => List<String>} [getKeys]
 */

/**
 * @typedef BackgroundImagesConfig
 * @property {number} count
 * @property {string} [description]
 * @property {{
 *  label?: stringres
 *  helperText?: string
 *  default?: string
 * }[]} [configs]
 */

/**
 * @template T
 * @callback ConvertToUploadFormat
 * @param {{ items: T }} task
 * @param {{ isNew: boolean }} params
 * @returns {any}
 */

/**
 * @template T
 * @typedef {TaskTypeConfig<T>} TaskType
 */

/**
 * @template T
 * @param {TaskTypeConfig<T>} config
 * @returns {TaskType<T>}
 */
export default function createTaskType(config) {
    return { ...config };
}

function getKeys(item) {
    return [
        `Primary Targets: ${item?.primary_targets?.join(', ') ?? 'N/A'}`,
        `Secondary Targets: ${item?.secondary_targets?.join(', ') ?? 'N/A'}`
    ]
}

export function createSpeakingTaskType(config) {
    return { getKeys, ...config };
}